import { usePage } from "@inertiajs/vue3";
import { ref } from "vue";

import type { DiscussionThread, SharedData } from "@/types";

const STORAGE_PREFIX = "thread_read";

function storageKey(userId: number, threadId: number): string {
  return `${STORAGE_PREFIX}:${userId}:${threadId}`;
}

function getUserId(): number | undefined {
  const page = usePage<SharedData>();
  return page.props.auth.user?.id;
}

/** Reactive counter — increment to force Vue re-renders after localStorage writes. */
export const readVersion = ref(0);

export function markRead(threadId: number, updatedAt: string): void {
  const userId = getUserId();
  if (!userId) return;

  localStorage.setItem(storageKey(userId, threadId), updatedAt);
  readVersion.value++;
}

export function isUnread(thread: DiscussionThread): boolean {
  // Reference readVersion so Vue tracks this as a dependency
  void readVersion.value;

  const userId = getUserId();
  if (!userId) return false;

  if (thread.is_participant === false) return false;

  const lastRead = localStorage.getItem(storageKey(userId, thread.id));
  if (!lastRead) return true;

  return new Date(thread.updated_at).getTime() > new Date(lastRead).getTime();
}
